<div class="modal-header">
  @if (!isNewArray) {
    <h4 class="modal-title h5" translate>Edit array</h4>
  }
  @if (isNewArray) {
    <h4 class="modal-title h5" translate>New array</h4>
  }
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form [formGroup]="gatewayArrayForm" (ngSubmit)="onSave()">
  <div class="modal-body">
    <div class="row">
      <div class="col-12 col-md-6">
        <!-- NAME -->
        <div class="form-group">
          <label for="name" translate>Name</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input name="name" id="name" formControlName="name" type="text" class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.name.errors }">

            @if (submitted && f.name.errors) {
              <div class="invalid-feedback">
                @if (f.name.errors.required) {
                  <span translate>Name required</span>
                }
                @if (f.name.errors.equalName) {
                  <span translate>Array name already used!</span>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-12 col-md-6">
          <!-- DATATYPE -->
          <div class="form-group">
            <label for="datatype" translate>Datatype</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            <ng-select id="datatype" name="datatype" formControlName="datatype"
              [ngClass]="{ 'is-invalid': submitted && f.datatype.errors }"
              [items]="dataTypes"
              (change)="onChangeDatatype($event)"
              bindLabel="name" bindValue="name">
            </ng-select>
            @if (submitted && f.datatype.errors) {
              <div class="invalid-feedback">
                @if (f.datatype.errors.required) {
                  <span translate>Type required</span>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <!-- CONFIGURED VALUES -->
      <div class="table-responsive">
        <table class="table va-middle">
          <thead>
            <tr>
              <th translate>Name</th>
              <th translate>Alias</th>
              <th translate>Datatype</th>
              <th class="text-right" translate>Action</th>
            </tr>
          </thead>
          <tbody>
            @for (value of copyGatewayArray.values; track value) {
              <tr>
                <td><b [innerText]="value.name"></b></td>
                <td [innerText]="value.alias"></td>
                <td [innerText]="value.datatype"></td>
                <td class="text-right">
                  <button type="button" class="btn btn-xs btn-outline-danger"
                    (click)="onRemoveValue(value)"
                    title="{{'Delete value' | translate}}"><span
                  class="fa-solid fa-trash"></span>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- SIGNAL SELECTION -->
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <ng-select #selectValue name="values" id="values" formControlName="values"
            [items]="valuesForDatatype" bindLabel="name" bindValue="name"
            [clearable]="false"
            (change)="onChangeValue($event)">
            <ng-template ng-option-tmp let-item="item">
              <div><span [innerText]="item.name"></span></div>
              @if (item.alias) {
                <small [innerText]="item.alias"></small>
              }
            </ng-template>
          </ng-select>
        </div>

      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="modal-footer-inner">
      <div class="row align-items-center flex-fill">
        <div class="col">
          <scitis-required-field-indicator-explanation></scitis-required-field-indicator-explanation>
        </div>
        <div class="col-auto">
          <button type="button" class="btn btn-outline-primary mr-2" (click)="onCancel()">
            <span translate>Cancel</span>
          </button>
          <button [disabled]="isDisabledSaveBtn" type="submit" class="btn btn-primary">
            <span translate>Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
